<template>
  <section class="event-day">
    <header class="event-day__header">
      <h4 class="event-day__title">
        {{ weekday }}, <strong>{{ formattedDate }}</strong>
      </h4>
    </header>

    <div class="event-day__content">
      <event-time
        v-for="event in events"
        :key="`${event.date}-${event.from}`"
        :reservation="reservation"
        :event="event"
      />
    </div>
  </section>
</template>

<script>
import eventTime from './eventTime.vue'
import dateHelper from '../functions/dateHelper'
import weekdayNames from '../functions/weekdayNames'
import monthNames from '../functions/monthNames'

export default {
  name: 'CEventDay',

  components: {
    eventTime
  },

  props: {
    date: {
      type: String,
      required: true
    },
    reservation: Boolean
  },

  computed: {
    dateObject () {
      return dateHelper.dateFromString(this.date)
    },
    events () {
      const dateComponents = dateHelper.formatDate(this.dateObject).split('-')
      const year = parseInt(dateComponents[0])
      const month = parseInt(dateComponents[1])
      const day = parseInt(dateComponents[2])

      if (!(year in this.$store.state.eventsByType)) {
        return false
      }

      if (!(month in this.$store.state.eventsByType[year])) {
        return false
      }

      if (!(day in this.$store.state.eventsByType[year][month])) {
        return false
      }

      return this.$store.state.eventsByType[year][month][day]
    },
    weekday () {
      const date = this.dateObject
      return weekdayNames(this.$i18n.locale)[date.getDay()]
    },
    formattedDate () {
      const date = this.dateObject

      let dateStr = ''
      const day = date.getDate()
      dateStr += day + '. '

      const month = date.getMonth()
      dateStr += monthNames(this.$i18n.locale)[month] + ' '

      dateStr += date.getFullYear()

      return dateStr
    }

  }
}
</script>

<style lang="scss">
@import "../css/variables";

.event-day {
  margin-bottom: $gutter-sm;

  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-md;
  }
}

.event-day__header {
  padding-bottom: $gutter-sm;
  border-bottom: $border-gap;
}

.event-day__title {
  font-size: 1.125em;
  font-weight: 500;
  text-transform: uppercase;
}
</style>
